import { actionType } from "../actions/klagekoderAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];
const klageKoderReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, actionType);

export default klageKoderReducer;
